import { Heart, Globe, Mail, Phone, MapPin, Copyright, Github, Linkedin, Twitter, ArrowUp } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative border-t bg-background">
      <div className="container py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">À propos de Médicace</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Votre compagnon santé numérique innovant, conçu pour simplifier la gestion de votre bien-être au quotidien. Notre plateforme offre des solutions intégrées pour une meilleure expérience de santé.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Liens Rapides</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <RouterLink to="/medications" className="text-muted-foreground hover:text-primary transition-colors">
                  Gestion des Médicaments
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/appointments" className="text-muted-foreground hover:text-primary transition-colors">
                  Rendez-vous
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/journal" className="text-muted-foreground hover:text-primary transition-colors">
                  Journal de Santé
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/emergency" className="text-muted-foreground hover:text-primary transition-colors">
                  Gestion d'Urgence
                </RouterLink>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 min-w-5 text-primary" />
                <span className="text-muted-foreground">alexiscarlenockson98@gmail.com</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 min-w-5 text-primary" />
                <span className="text-muted-foreground">+90 551 097 4587</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-5 w-5 min-w-5 text-primary" />
                <span className="text-muted-foreground">Cap-Haïtien, Haïti</span>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="h-5 w-5 min-w-5 text-primary" />
                <span className="text-muted-foreground">Disponible dans plusieurs pays</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Suivez-nous</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-8" />

        {/* Bottom Section */}
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Copyright className="h-4 w-4" />
            <span>{new Date().getFullYear()} Médicace. Tous droits réservés.</span>
          </div>
          <div className="flex items-center space-x-1">
            <span className="text-sm text-muted-foreground">Fait avec</span>
            <Heart className="h-4 w-4 text-primary" />
            <span className="text-sm text-muted-foreground">par</span>
            <a href="#" className="text-sm font-medium text-primary hover:underline">
              Médicace
            </a>
          </div>
          <Button
            variant="outline"
            size="icon"
            className="rounded-full shadow-lg hover:shadow-xl transition-all"
            onClick={scrollToTop}
            aria-label="Retourner en haut"
          >
            <ArrowUp className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </footer>
  );
};
